import { AvailableModules, Features } from 'generated/featureDefinitions'

export const isValidModule = (value: string | null | undefined): value is AvailableModules => {
  if (!value) return false
  const candidates = value
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
  return candidates.some((candidate) =>
    Object.values(AvailableModules).some((enumValue) => enumValue === candidate)
  )
}

export const isValidFeature = (value: string | null | undefined): value is Features => {
  if (!value) return false
  return Object.values(Features).some((enumValue) => enumValue === value)
}
